module.exports = __webpack_public_path__ + "static/media/Logo_Parita_di_genere_white.bebe4a99.svg";